import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-6 text-center">
      <div className="mb-4 text-6xl font-extrabold text-white/10">404</div>
      <h1 className="mb-3 text-2xl font-bold">This page isn't in your library</h1>
      <p className="mb-8 text-sm text-white/50">
        The story you're looking for may have been regrouped, or the link is out of date.
      </p>
      <Link to="/" className="rounded-md bg-white px-6 py-3 text-sm font-bold text-black transition hover:bg-white/85">
        Back to Home
      </Link>
    </div>
  );
}